module.exports = __webpack_public_path__ + "static/photo12-c15704b1b9738e79d90af8ddd728c174.png";